import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getFirestore } from 'firebase/firestore'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'

const firebaseConfig = {
  apiKey: "AIzaSyB7Exsrg9gOIeswGx1mdW97HS2JcIpgTZM",
  authDomain: "central-f9568.firebaseapp.com",
  projectId: "central-f9568",
  storageBucket: "central-f9568.firebasestorage.app",
  messagingSenderId: "1029000143854",
  appId: "1:1029000143854:web:cdeeb3c1b3ea4d55af64ff",
  measurementId: "G-0BRZ5J580S"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Analytics (only in browser)
let analytics = null
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app)
}

// Initialize Firestore
const db = getFirestore(app)

// Initialize Auth
const auth = getAuth(app)
const googleProvider = new GoogleAuthProvider()

export { app, analytics, db, auth, googleProvider }
